export interface GeofenceCenter {
  groupId: string;
  name: string;
  latitude: number;
  longitude: number;
}

export const DRIFT_MILES_CUTOFF = 0.25;
export const DRIFT_JITTER_FLOOR_FT = 150;
export const DRIFT_FT_ROUNDING = 10;
export const FT_PER_MILE = 5280;

const EARTH_RADIUS_MILES = 3958.8;

export function haversineMiles(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_MILES * Math.asin(Math.sqrt(Math.min(1, a)));
}

export function formatMilesOneDecimal(miles: number): string {
  return `${miles.toFixed(1)} mi`;
}

/** "≈ 900 ft" under the cutoff, "2.1 mi" at or above; null below the GPS jitter floor. */
export function driftLabel(miles: number): string | null {
  const feet = miles * FT_PER_MILE;
  if (feet < DRIFT_JITTER_FLOOR_FT) return null;
  if (miles < DRIFT_MILES_CUTOFF) {
    return `≈ ${Math.round(feet / DRIFT_FT_ROUNDING) * DRIFT_FT_ROUNDING} ft`;
  }
  return formatMilesOneDecimal(miles);
}

export function nearestCenter(
  latitude: number,
  longitude: number,
  centers: GeofenceCenter[],
): { center: GeofenceCenter; miles: number } | null {
  let best: { center: GeofenceCenter; miles: number } | null = null;
  for (const center of centers ?? []) {
    if (center.latitude == null || center.longitude == null) continue;
    const miles = haversineMiles(latitude, longitude, center.latitude, center.longitude);
    if (!best || miles < best.miles) best = { center, miles };
  }
  return best;
}
